import axios from 'axios';
import { hasFeature } from 'utils/featureFlags';
import { getSaudagarOutlets } from 'api/outlets';
import {
  ALL_OUTLETS,
  BILLINGS,
  CANCEL_SUBSCRIPTION,
  FEATURE_SUBSCRIPTION_PRICE,
  FEATURE_SUBSCRIPTION_PRICE_FROM_SERVICE,
  OUTLETS,
  RULES,
  RULES_FROM_SERVICE,
  SUBSCRIPTION_STATUS,
  VERIFY_BILLING,
  IS_ACTIVE_SUBCRIPTIONS_URL,
  GET_PRORATE_PRICE,
  VERIFY_BILLING_FOR_EXTEND_OUTLET,
} from './constant';

function reject(error) {
  let eobj;
  if (error.response) {
    const { data } = error.response;
    if (data.errors) {
      eobj = new Error(data.errors);
    } else if (data.message) {
      eobj = new Error(data.message);
    } else {
      eobj = new Error(error.message);
    }
  } else {
    eobj = new Error(error.message);
  }
  return Promise.reject(eobj);
}

export function getBillings(params) {
  return axios.get(BILLINGS, { params, withCredentials: true }).catch(reject);
}

export function getOutlets(params) {
  return axios.get(OUTLETS, { params, withCredentials: true }).catch(reject);
}

export function getRules(params) {
  const url = hasFeature('business-type-new-api') ? RULES_FROM_SERVICE : RULES;
  const isWithCredentials = !hasFeature('business-type-new-api');
  return axios
    .get(url, { params, withCredentials: isWithCredentials })
    .catch(reject);
}

export function getSubscriptionStatus(params) {
  return axios
    .post(SUBSCRIPTION_STATUS, null, { params, withCredentials: true })
    .catch(reject);
}

export function verifyBilling(params) {
  return axios
    .post(VERIFY_BILLING, params, { withCredentials: true })
    .catch(error => {
      return Promise.reject(error.response);
    });
}

export function verifyBillingForExtendOutlet(params) {
  return axios
    .post(VERIFY_BILLING_FOR_EXTEND_OUTLET, params, { withCredentials: true })
    .catch(error => {
      return Promise.reject(error.response);
    });
}

export function getFeatureSubscriptionPrice() {
  const url = hasFeature('business-type-new-api')
    ? FEATURE_SUBSCRIPTION_PRICE_FROM_SERVICE
    : FEATURE_SUBSCRIPTION_PRICE;
  const isWithCredentials = !hasFeature('business-type-new-api');

  if (hasFeature('business-type-new-api')) {
    return axios.get(url, { withCredentials: isWithCredentials }).catch(reject);
  }

  return axios
    .post(url, {}, { withCredentials: isWithCredentials })
    .catch(reject);
}

export function cancelSubscription(params) {
  return axios
    .put(CANCEL_SUBSCRIPTION, params, { withCredentials: true })
    .catch(reject);
}

export function getAllOutlets() {
  if (hasFeature('enable-cmp-indicators')) {
    return getSaudagarOutlets({ active: 'all' }).then(resp => resp.data);
  }

  return axios.get(ALL_OUTLETS, { withCredentials: true }).catch(reject);
}

export function updateIsActiveSubcription(outletId, isActive) {
  const params = { id: outletId, isActive };
  return axios
    .put(IS_ACTIVE_SUBCRIPTIONS_URL, params, { withCredentials: true })
    .catch(reject);
}

export function getProratePrice({ params }) {
  return axios
    .get(GET_PRORATE_PRICE, { params }, { withCredentials: true })
    .catch(reject);
}
